import { FC } from "react";
import classNames from "classnames";
import { filterEmptyValue } from "../../../utils/utils";
import { ScanPageRightItemEnum, ScanPageRightGoodItemProps } from "../../interface";

const GoodItem: FC<ScanPageRightGoodItemProps> = props => {
  const { className, style, options, } = props;
  const classes = classNames('body-right-good-item', className);
  return (
    <div className={classes} style={style}>
      {
        options?.map((option, index) => {
          const { label, items, key, value: optionValue } = option;
          return (
            <div className="good-info-card" key={key || index}>
              {!!label && <div className="good-info-card-title">{label}</div>}
              <div className="good-info-card-content">
                {
                  items?.map((item, index) => {
                    const { label, value: itemValue, valueType } = item;
                    const itemClass = valueType ? `text-${valueType}` : '';
                    return (
                      <>
                        <span className="item-label">{label}</span>
                        <span className="item-text">
                          <span>(</span>
                          <span className={itemClass}>{filterEmptyValue(itemValue)}</span>
                          <span>)</span>
                        </span>
                        {
                          (index !== (items.length - 1)) && <span className="item-division">/</span>
                        }
                      </>
                    );
                  })
                }
                {optionValue}
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

GoodItem.displayName = ScanPageRightItemEnum.RightGoodItem;

export default GoodItem;